import { watch } from 'vue'
import { useOnboardingStore } from '../stores/onboardingStore'
import type { TOnboardingSection } from '../types/TOnboardingSection'

/**
 * Перезагружает данные экрана при входе в онбординг раздела и выходе из него.
 * Нужен экранам, чьи ручки идут через `onboardingApiUrl()` и на которых онбординг
 * запускается поверх уже загруженных данных.
 */
export function useOnboardingDemoReload(section: TOnboardingSection, reload: () => unknown) {
  const onboardingStore = useOnboardingStore()

  watch(() => onboardingStore.scenario?.section === section, () => {
    void reload()
  })
}
